/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type MeetingReliefSettingVisibility = "DisabledByPaywall" | "HideSetting" | "ShowWithBadge" | "ShowWithoutBadge" | "%future added value";
export type GoalsWrapper_org = {
    readonly userGoals: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly goalId: string;
                readonly name: string;
                readonly isDeleted: boolean;
            } | null;
        } | null> | null;
    } | null;
    readonly featureGrid: {
        readonly __typename: "FeatureGrid";
        readonly featureStates: {
            readonly meetingReliefSettingVisibility: MeetingReliefSettingVisibility;
        };
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $fragmentRefs": FragmentRefs<"MeetingReliefGoal_org">;
    readonly " $refType": "GoalsWrapper_org";
};
export type GoalsWrapper_org$data = GoalsWrapper_org;
export type GoalsWrapper_org$key = {
    readonly " $data"?: GoalsWrapper_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"GoalsWrapper_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GoalsWrapper_org",
    "selections": [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000000
                }
            ],
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "userGoals",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "GoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "goalId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isDeleted",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": "userGoals(first:1000000)"
        },
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "featureGrid",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "FeatureStates",
                            "kind": "LinkedField",
                            "name": "featureStates",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "meetingReliefSettingVisibility",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "type": "FeatureGrid",
                    "abstractKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusCode",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "type": "GraphEntityError",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MeetingReliefGoal_org"
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = '5c9df3399e37ab623054159db7cedd24';
export default node;
